// src/core/AppMode.ts
var AppMode = /* @__PURE__ */ ((AppMode2) => {
  AppMode2[AppMode2["ORG_SELECTION"] = 0] = "ORG_SELECTION";
  AppMode2[AppMode2["TWIN_SELECTION"] = 1] = "TWIN_SELECTION";
  AppMode2[AppMode2["LIVE"] = 2] = "LIVE";
  AppMode2[AppMode2["HISTORICAL"] = 3] = "HISTORICAL";
  AppMode2[AppMode2["EDIT"] = 4] = "EDIT";
  AppMode2[AppMode2["DASHBOARD_UTILISATION"] = 5] = "DASHBOARD_UTILISATION";
  AppMode2[AppMode2["INSIGHTS"] = 6] = "INSIGHTS";
  AppMode2[AppMode2["EQUIPMENT"] = 7] = "EQUIPMENT";
  AppMode2[AppMode2["OPERATIONS"] = 8] = "OPERATIONS";
  return AppMode2;
})(AppMode || {});

// src/core/TwinEntityType.ts
var TwinEntityType = /* @__PURE__ */ ((TwinEntityType2) => {
  TwinEntityType2["AREA"] = "Area";
  TwinEntityType2["ASSET"] = "Asset";
  TwinEntityType2["CATEGORY"] = "Category";
  TwinEntityType2["CHUTE"] = "Chute";
  TwinEntityType2["FLOOR"] = "Floor";
  TwinEntityType2["NFAREA"] = "NFArea";
  TwinEntityType2["SITE"] = "Site";
  TwinEntityType2["STRUCTURE"] = "Structure";
  TwinEntityType2["UNKNOWN"] = "Unknown";
  TwinEntityType2["TICKET"] = "Ticket";
  TwinEntityType2["ZONE"] = "Zone";
  TwinEntityType2["WALL"] = "Wall";
  TwinEntityType2["EVENT"] = "Event";
  TwinEntityType2["STATION"] = "STATION";
  TwinEntityType2["OPERATOR"] = "OPERATOR";
  return TwinEntityType2;
})(TwinEntityType || {});

// src/core/FilterType.ts
var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2[FilterType2["ENTITY"] = 0] = "ENTITY";
  FilterType2[FilterType2["TAG"] = 1] = "TAG";
  FilterType2[FilterType2["ASSET"] = 2] = "ASSET";
  FilterType2[FilterType2["DATE"] = 3] = "DATE";
  FilterType2[FilterType2["TIME"] = 4] = "TIME";
  FilterType2[FilterType2["PEAK"] = 5] = "PEAK";
  FilterType2[FilterType2["EQUIPMENT_TYPE"] = 6] = "EQUIPMENT_TYPE";
  FilterType2[FilterType2["MANUFACTURER"] = 7] = "MANUFACTURER";
  FilterType2[FilterType2["FLOOR"] = 8] = "FLOOR";
  return FilterType2;
})(FilterType || {});

// src/core/DataMode.ts
var DataMode = /* @__PURE__ */ ((DataMode2) => {
  DataMode2[DataMode2["LIVE"] = 0] = "LIVE";
  DataMode2[DataMode2["TIME_SERIES"] = 1] = "TIME_SERIES";
  return DataMode2;
})(DataMode || {});

// src/core/FloorplannerImportState.ts
var FLOORPLANNER_IMPORT_STATES = [
  "awaiting-fml",
  "importing-fml",
  "awaiting-add-to-map",
  "adding-to-map",
  "awaiting-save-to-dgraph",
  "saving-to-dgraph",
  "saved-to-dgraph"
];

// src/auth/Roles.ts
var Roles = /* @__PURE__ */ ((Roles2) => {
  Roles2["CUSTOMER_ADMIN"] = "CUSTOMER_ADMIN";
  Roles2["CUSTOMER_USER"] = "CUSTOMER_USER";
  Roles2["PARTNER_USER"] = "PARTNER_USER";
  Roles2["TL_ADMIN"] = "TL_ADMIN";
  return Roles2;
})(Roles || {});
var permissionsLookup = {
  // `permission_peak_hours` gates the Peak Hours toggle inside Insights mode to TL_ADMIN.
  // Insights mode itself is GA (no permission required); the toggle is hidden from customers
  // because its peak-hours time-window definitions are still under review.
  TL_ADMIN: ["permission_twin_editing", "permission_peak_hours"]
};
function getUserPermissions(roles) {
  const permissions = /* @__PURE__ */ new Set();
  roles.forEach((role) => {
    const foundPermissions = permissionsLookup[role];
    if (foundPermissions) {
      foundPermissions.forEach((permission) => permissions.add(permission));
    }
  });
  return permissions;
}

// src/map/MapLocationAndCamera.ts
var DEFAULT_MAP_ORIGIN = {
  latitude: 51.478091,
  longitude: -0.160382
};
var DEFAULT_CAMERA_CONFIG = {
  zoom: 19,
  bearing: 340,
  pitch: 70
};

// src/ui/Align.ts
var Align = /* @__PURE__ */ ((Align2) => {
  Align2[Align2["CENTER"] = 0] = "CENTER";
  Align2[Align2["LEFT"] = 1] = "LEFT";
  Align2[Align2["RIGHT"] = 2] = "RIGHT";
  return Align2;
})(Align || {});

// src/ui/FieldMode.ts
var FieldMode = /* @__PURE__ */ ((FieldMode2) => {
  FieldMode2[FieldMode2["READ"] = 0] = "READ";
  FieldMode2[FieldMode2["EDIT"] = 1] = "EDIT";
  return FieldMode2;
})(FieldMode || {});

// src/ui/TabPanel.ts
var TabPanel = /* @__PURE__ */ ((TabPanel2) => {
  TabPanel2["ORGS"] = "ORGS";
  TabPanel2["TWINS"] = "TWINS";
  TabPanel2["ASSETS"] = "ASSETS";
  return TabPanel2;
})(TabPanel || {});

// src/ui/PanelAnchorPos.ts
var PanelAnchorPos = /* @__PURE__ */ ((PanelAnchorPos2) => {
  PanelAnchorPos2[PanelAnchorPos2["TOP_LEFT"] = 0] = "TOP_LEFT";
  PanelAnchorPos2[PanelAnchorPos2["TOP_CENTRE"] = 1] = "TOP_CENTRE";
  PanelAnchorPos2[PanelAnchorPos2["TOP_RIGHT"] = 2] = "TOP_RIGHT";
  PanelAnchorPos2[PanelAnchorPos2["CENTRE"] = 3] = "CENTRE";
  PanelAnchorPos2[PanelAnchorPos2["CENTRE_LEFT"] = 4] = "CENTRE_LEFT";
  PanelAnchorPos2[PanelAnchorPos2["CENTRE_RIGHT"] = 5] = "CENTRE_RIGHT";
  PanelAnchorPos2[PanelAnchorPos2["BOTTOM_LEFT"] = 6] = "BOTTOM_LEFT";
  PanelAnchorPos2[PanelAnchorPos2["BOTTOM_CENTRE"] = 7] = "BOTTOM_CENTRE";
  PanelAnchorPos2[PanelAnchorPos2["BOTTOM_RIGHT"] = 8] = "BOTTOM_RIGHT";
  return PanelAnchorPos2;
})(PanelAnchorPos || {});

// src/ui/PageMode.ts
var PageMode = /* @__PURE__ */ ((PageMode2) => {
  PageMode2[PageMode2["LOGIN"] = 0] = "LOGIN";
  PageMode2[PageMode2["RESET_PASSWORD"] = 1] = "RESET_PASSWORD";
  return PageMode2;
})(PageMode || {});

// src/ui/LabelMode.ts
var LabelMode = /* @__PURE__ */ ((LabelMode2) => {
  LabelMode2[LabelMode2["BRIEF"] = 0] = "BRIEF";
  LabelMode2[LabelMode2["FULL"] = 1] = "FULL";
  return LabelMode2;
})(LabelMode || {});

// src/ui/TimeUnit.ts
var TimeUnit = /* @__PURE__ */ ((TimeUnit2) => {
  TimeUnit2[TimeUnit2["WEEK"] = 0] = "WEEK";
  TimeUnit2[TimeUnit2["MONTH"] = 1] = "MONTH";
  return TimeUnit2;
})(TimeUnit || {});

// src/message/Message.ts
var Feedback = /* @__PURE__ */ ((Feedback2) => {
  Feedback2["NONE"] = "NONE";
  Feedback2["POSITIVE"] = "POSITIVE";
  Feedback2["NEGATIVE"] = "NEGATIVE";
  return Feedback2;
})(Feedback || {});

// src/log/LogLevel.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["DEBUG"] = "DEBUG";
  LogLevel2["INFO"] = "INFO";
  LogLevel2["WARNING"] = "WARNING";
  LogLevel2["ERROR"] = "ERROR";
  LogLevel2["CRITICAL"] = "CRITICAL";
  LogLevel2["FATAL"] = "FATAL";
  return LogLevel2;
})(LogLevel || {});

// src/indicator/IndicatorColor.ts
var IndicatorColor = /* @__PURE__ */ ((IndicatorColor2) => {
  IndicatorColor2["BLACK"] = "#000000";
  IndicatorColor2["WHITE"] = "#FFFFFF";
  IndicatorColor2["NA"] = "#FFFFFF";
  IndicatorColor2["ZERO"] = "#FAFAFA";
  IndicatorColor2["VERY_LOW"] = "#E0FFFE";
  IndicatorColor2["LOW"] = "#BEF4F2";
  IndicatorColor2["MEDIUM_LOW"] = "#A6EDED";
  IndicatorColor2["MEDIUM"] = "#8FE6E8";
  IndicatorColor2["MEDIUM_HIGH"] = "#5FD8DF";
  IndicatorColor2["HIGH"] = "#3DD6D4";
  IndicatorColor2["VERY_HIGH"] = "#1BB6D9";
  IndicatorColor2["EXTREMELY_HIGH"] = "#C50F1F";
  IndicatorColor2["NA_NOT_SELECTED"] = "#FFFFFF";
  IndicatorColor2["ZERO_NOT_SELECTED"] = "#FAFAFA";
  IndicatorColor2["VERY_LOW_NOT_SELECTED"] = "#E0E0E0";
  IndicatorColor2["LOW_NOT_SELECTED"] = "#CCCCCC";
  IndicatorColor2["MEDIUM_LOW_NOT_SELECTED"] = "#C2C2C2";
  IndicatorColor2["MEDIUM_NOT_SELECTED"] = "#B8B8B8";
  IndicatorColor2["MEDIUM_HIGH_NOT_SELECTED"] = "#A8A8A8";
  IndicatorColor2["HIGH_NOT_SELECTED"] = "#8F8F8F";
  IndicatorColor2["VERY_HIGH_NOT_SELECTED"] = "#808080";
  IndicatorColor2["EXTREMELY_HIGH_NOT_SELECTED"] = "#707070";
  IndicatorColor2["INITIAL"] = "#E4FFFF";
  IndicatorColor2["CRYSTAL_TINT"] = "#CFF7F7";
  IndicatorColor2["TEAL_LIGHT"] = "#A0EBE6";
  IndicatorColor2["TEAL_MEDIUM_LIGHT"] = "#6FDBD2";
  IndicatorColor2["TEAL_MEDIUM"] = "#42DBD0";
  IndicatorColor2["TEAL_ACCENT"] = "#34CED7";
  IndicatorColor2["BLUE_ACCENT_LIGHT"] = "#1BB6D9";
  IndicatorColor2["BLUE_ACCENT"] = "#0EAAE8";
  IndicatorColor2["BLUE_BRIGHT"] = "#5BA8D7";
  IndicatorColor2["BLUE_MUTED"] = "#5785D5";
  IndicatorColor2["BLUE_VIOLET"] = "#8077BE";
  IndicatorColor2["PINK_MEDIUM"] = "#A24489";
  IndicatorColor2["PINK_VIBRANT"] = "#D2377A";
  IndicatorColor2["INITIAL_NOT_SELECTED"] = "#FAFAFA";
  IndicatorColor2["CRYSTAL_TINT_NOT_SELECTED"] = "#E0E0E0";
  IndicatorColor2["TEAL_LIGHT_NOT_SELECTED"] = "#CFCFCF";
  IndicatorColor2["TEAL_MEDIUM_LIGHT_NOT_SELECTED"] = "#BFBFBF";
  IndicatorColor2["TEAL_MEDIUM_NOT_SELECTED"] = "#AFAFAF";
  IndicatorColor2["TEAL_ACCENT_NOT_SELECTED"] = "#9F9F9F";
  IndicatorColor2["BLUE_ACCENT_LIGHT_NOT_SELECTED"] = "#8F8F8F";
  IndicatorColor2["BLUE_ACCENT_NOT_SELECTED"] = "#808080";
  IndicatorColor2["BLUE_BRIGHT_NOT_SELECTED"] = "#707070";
  IndicatorColor2["BLUE_MUTED_NOT_SELECTED"] = "#606060";
  IndicatorColor2["BLUE_VIOLET_NOT_SELECTED"] = "#505050";
  IndicatorColor2["PINK_MEDIUM_NOT_SELECTED"] = "#404040";
  IndicatorColor2["PINK_VIBRANT_NOT_SELECTED"] = "#303030";
  return IndicatorColor2;
})(IndicatorColor || {});

// src/middleware/Notification.ts
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["SYSTEM"] = "SYSTEM";
  NotificationType2["ALERT"] = "ALERT";
  NotificationType2["INSIGHT"] = "INSIGHT";
  NotificationType2["ADMIN"] = "ADMIN";
  NotificationType2["RELEASE"] = "RELEASE";
  return NotificationType2;
})(NotificationType || {});

// src/middleware/Organisation.ts
var OrganisationLifecycleStageValues = /* @__PURE__ */ ((OrganisationLifecycleStageValues2) => {
  OrganisationLifecycleStageValues2["Initiated"] = "initiated";
  OrganisationLifecycleStageValues2["OrganisationCreated"] = "organisationCreated";
  OrganisationLifecycleStageValues2["FirstTwinPrep"] = "firstTwinPrep";
  OrganisationLifecycleStageValues2["AdminUserCreated"] = "adminUserCreated";
  OrganisationLifecycleStageValues2["TermsAccepted"] = "termsAccepted";
  OrganisationLifecycleStageValues2["LiveTwin"] = "liveTwin";
  OrganisationLifecycleStageValues2["OnlySuspendedTwins"] = "onlySuspendedTwins";
  OrganisationLifecycleStageValues2["OnlyArchivedTwins"] = "onlyArchivedTwins";
  OrganisationLifecycleStageValues2["Archived"] = "archived";
  OrganisationLifecycleStageValues2["Deleted"] = "deleted";
  return OrganisationLifecycleStageValues2;
})(OrganisationLifecycleStageValues || {});

// src/middleware/TwinLifecycleStageValues.ts
var TwinLifecycleStageValues = /* @__PURE__ */ ((TwinLifecycleStageValues2) => {
  TwinLifecycleStageValues2["Initiated"] = "initiated";
  TwinLifecycleStageValues2["ThreeDScene"] = "3dScene";
  TwinLifecycleStageValues2["GraphSaved"] = "graphSaved";
  TwinLifecycleStageValues2["WaitingForCCTV"] = "waitingForCCTV";
  TwinLifecycleStageValues2["PipelineReady"] = "pipelineReady";
  TwinLifecycleStageValues2["PipelineCreated"] = "pipelineCreated";
  TwinLifecycleStageValues2["DataFlowing"] = "dataFlowing";
  TwinLifecycleStageValues2["LiveTwin"] = "liveTwin";
  TwinLifecycleStageValues2["PlannedPause"] = "plannedPause";
  TwinLifecycleStageValues2["Suspended"] = "suspended";
  TwinLifecycleStageValues2["Archived"] = "archived";
  TwinLifecycleStageValues2["Deleted"] = "deleted";
  return TwinLifecycleStageValues2;
})(TwinLifecycleStageValues || {});
var TWIN_LIFECYCLE_RANK = {
  ["initiated" /* Initiated */]: 10,
  ["3dScene" /* ThreeDScene */]: 20,
  ["graphSaved" /* GraphSaved */]: 30,
  ["pipelineReady" /* PipelineReady */]: 40,
  ["pipelineCreated" /* PipelineCreated */]: 50,
  ["waitingForCCTV" /* WaitingForCCTV */]: 60,
  ["dataFlowing" /* DataFlowing */]: 70,
  ["liveTwin" /* LiveTwin */]: 80
};

// src/middleware/OpeningHours.ts
var LAUNCH_HOURS_REASONS = [
  "covered",
  "upcoming",
  "no_timezone",
  "no_standard",
  "no_open_day"
];
var OPENING_HOURS_CHANGED_CODE = "opening-hours-changed";

// src/middleware/Template.ts
var Template = /* @__PURE__ */ ((Template2) => {
  Template2["Gym"] = "Gym";
  Template2["Truck"] = "Truck";
  Template2["Event"] = "Event";
  return Template2;
})(Template || {});

// src/middleware/Camera.ts
var CAMERA_TYPES = ["Bullet", "Dome", "Turret", "PTZ", "Fisheye", "Cube"];
var CAMERA_RESOLUTIONS = [
  "2MP (1080p)",
  "4MP (2K)",
  "5MP",
  "8MP (4K)"
];
var CAMERA_LENS_FOCAL_LENGTHS = [2.8, 4, 6, 8];

// src/settings/Section.ts
var Section = /* @__PURE__ */ ((Section2) => {
  Section2["TOP"] = "TOP";
  Section2["BOTTOM"] = "BOTTOM";
  Section2["LEFT"] = "LEFT";
  Section2["RIGHT"] = "RIGHT";
  return Section2;
})(Section || {});

// src/settings/DataScope.ts
var DataScope = /* @__PURE__ */ ((DataScope2) => {
  DataScope2[DataScope2["TOTAL_HOURS"] = 0] = "TOTAL_HOURS";
  DataScope2[DataScope2["TOTAL_DAYS"] = 1] = "TOTAL_DAYS";
  DataScope2[DataScope2["ACTIVE_HOURS"] = 2] = "ACTIVE_HOURS";
  DataScope2[DataScope2["ACTIVE_DAYS"] = 3] = "ACTIVE_DAYS";
  return DataScope2;
})(DataScope || {});

// src/settings/CopilotType.ts
var CopilotType = /* @__PURE__ */ ((CopilotType2) => {
  CopilotType2["SUPPORT"] = "SUPPORT";
  CopilotType2["ANALYTICS"] = "ANALYTICS";
  return CopilotType2;
})(CopilotType || {});

// src/settings/Environment.ts
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["INDOOR"] = "INDOOR";
  Environment2["OUTDOOR"] = "OUTDOOR";
  return Environment2;
})(Environment || {});

// src/data/weekdays.ts
var WEEKDAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

// src/nola/index.ts
var MetricEventValueType = /* @__PURE__ */ ((MetricEventValueType2) => {
  MetricEventValueType2[MetricEventValueType2["Count"] = 0] = "Count";
  MetricEventValueType2[MetricEventValueType2["QueueCount"] = 1] = "QueueCount";
  MetricEventValueType2[MetricEventValueType2["NoPeopleInMins"] = 2] = "NoPeopleInMins";
  return MetricEventValueType2;
})(MetricEventValueType || {});
var MetricValueType = /* @__PURE__ */ ((MetricValueType2) => {
  MetricValueType2[MetricValueType2["event"] = 0] = "event";
  MetricValueType2[MetricValueType2["count"] = 1] = "count";
  MetricValueType2[MetricValueType2["interval"] = 2] = "interval";
  MetricValueType2[MetricValueType2["weather"] = 3] = "weather";
  MetricValueType2[MetricValueType2["q_estimate"] = 4] = "q_estimate";
  MetricValueType2[MetricValueType2["stay_time"] = 5] = "stay_time";
  MetricValueType2[MetricValueType2["entry_to_exit_time"] = 6] = "entry_to_exit_time";
  MetricValueType2[MetricValueType2["cross"] = 7] = "cross";
  MetricValueType2[MetricValueType2["CDP"] = 8] = "CDP";
  return MetricValueType2;
})(MetricValueType || {});
var ServiceType = /* @__PURE__ */ ((ServiceType2) => {
  ServiceType2[ServiceType2["AREA"] = 0] = "AREA";
  return ServiceType2;
})(ServiceType || {});
var TrackSide = /* @__PURE__ */ ((TrackSide2) => {
  TrackSide2[TrackSide2["TOP"] = 0] = "TOP";
  TrackSide2[TrackSide2["MIDPOINT"] = 1] = "MIDPOINT";
  TrackSide2[TrackSide2["BOTTOM"] = 2] = "BOTTOM";
  return TrackSide2;
})(TrackSide || {});

// src/twinsense/TwinSenseMessageDirection.ts
var TwinSenseMessageDirection = /* @__PURE__ */ ((TwinSenseMessageDirection2) => {
  TwinSenseMessageDirection2["SENT"] = "Sent";
  TwinSenseMessageDirection2["RECEIVED"] = "Received";
  return TwinSenseMessageDirection2;
})(TwinSenseMessageDirection || {});

// src/twinsense/TwinSenseMessageKind.ts
var TwinSenseMessageKind = /* @__PURE__ */ ((TwinSenseMessageKind2) => {
  TwinSenseMessageKind2["SKELETON_DETECTION"] = "SkeletonDetection";
  TwinSenseMessageKind2["MISS_FRAME"] = "MissFrame";
  TwinSenseMessageKind2["RTSP_STATUS"] = "RTSPStatus";
  TwinSenseMessageKind2["OPS_METRICS"] = "OpsMetrics";
  TwinSenseMessageKind2["FRAME_SPLIT_CONFIG"] = "FrameSplitConfig";
  TwinSenseMessageKind2["FRAME_PROCESSING_CONFIG"] = "FrameProcessingConfig";
  TwinSenseMessageKind2["RTSP_CONFIG"] = "RTSPConfig";
  TwinSenseMessageKind2["SHUTDOWN"] = "Shutdown";
  TwinSenseMessageKind2["RESTART"] = "Restart";
  TwinSenseMessageKind2["CAPTURE_FRAMES"] = "CaptureFrames";
  return TwinSenseMessageKind2;
})(TwinSenseMessageKind || {});

// src/twinsense/TwinSenseMessageType.ts
var TwinSenseMessageType = /* @__PURE__ */ ((TwinSenseMessageType2) => {
  TwinSenseMessageType2["CONFIG"] = "Config";
  TwinSenseMessageType2["COMMAND"] = "Command";
  TwinSenseMessageType2["INFERENCE"] = "Inference";
  TwinSenseMessageType2["OPERATION"] = "Operation";
  return TwinSenseMessageType2;
})(TwinSenseMessageType || {});

// src/twinsense/TwinSenseQosLevel.ts
var TwinSenseQosLevel = /* @__PURE__ */ ((TwinSenseQosLevel2) => {
  TwinSenseQosLevel2["QOS_DEFAULT"] = "QOS_DEFAULT";
  return TwinSenseQosLevel2;
})(TwinSenseQosLevel || {});

// src/twin-planner/FloorPlanner.ts
var MAX_ASSET_UID_LENGTH = 64;
var normaliseAssetUid = (value) => {
  if (typeof value === "number") {
    return Number.isSafeInteger(value) && value > 0 ? String(value) : void 0;
  }
  if (typeof value !== "string") return void 0;
  const id = value.trim();
  if (id === "" || id === "0") return void 0;
  return id.length > MAX_ASSET_UID_LENGTH ? void 0 : id;
};

// src/twin-planner/modelFileName.ts
var MAX_MODEL_FILE_NAME_LENGTH = 255;
var HAS_EXTENSION = /\.[a-zA-Z0-9]+$/;
var MODEL_EXTENSION = ".glb";
var effectiveModelFileLength = (name) => HAS_EXTENSION.test(name) ? name.length : name.length + MODEL_EXTENSION.length;
var resolveModelFileName = (reference) => HAS_EXTENSION.test(reference) ? reference : `${reference}${MODEL_EXTENSION}`;
var CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;
var PATH_SEPARATORS = /[/\\:]/;
var URL_STRUCTURAL_CHARACTERS = /[?#&%]/;
var sharedScreenProblem = (name) => {
  if (name === "") {
    return "cannot be blank.";
  }
  if (effectiveModelFileLength(name) > MAX_MODEL_FILE_NAME_LENGTH) {
    return `cannot be longer than ${MAX_MODEL_FILE_NAME_LENGTH} characters.`;
  }
  if (CONTROL_CHARACTERS.test(name)) {
    return "cannot contain control characters.";
  }
  if (PATH_SEPARATORS.test(name)) {
    return "cannot contain a path separator \u2014 models live at the root of the asset store.";
  }
  if (name.includes("..")) {
    return 'cannot contain "..".';
  }
  if (URL_STRUCTURAL_CHARACTERS.test(name)) {
    return 'cannot contain "?", "#", "&" or "%" \u2014 those characters break the signed model URL.';
  }
  if (name.startsWith(".")) {
    return "cannot start with a dot \u2014 those are hidden files and macOS resource forks, not 3D models.";
  }
  if (name !== name.trim()) {
    return "cannot start or end with a space \u2014 no model file in the asset store is named that way.";
  }
  return null;
};
var modelReferenceProblem = (name) => {
  const shared = sharedScreenProblem(name);
  if (shared !== null) return shared;
  if (HAS_EXTENSION.test(name) && !name.toLowerCase().endsWith(MODEL_EXTENSION)) {
    return 'must be a .glb file in the asset store, e.g. "Benches+Bench.glb".';
  }
  return null;
};
var isModelReference = (name) => modelReferenceProblem(name) === null;
var isSelectableModelFileName = (name) => sharedScreenProblem(name) === null && name.toLowerCase().endsWith(MODEL_EXTENSION);

// src/twin-planner/modelFileDisplay.ts
var SEPARATOR = /[_\-+\s]/;
var SEPARATOR_RUN = /[_\-+\s]+/g;
var GLB_SUFFIX = /\.glb$/i;
var isSeparator = (character) => SEPARATOR.test(character);
var stripSuffix = (name) => name.replace(GLB_SUFFIX, "");
var groupBoundaryAt = (base) => {
  for (let index = 1; index < base.length - 1; index += 1) {
    if (base.charAt(index) === "+" && !isSeparator(base.charAt(index - 1)) && !isSeparator(base.charAt(index + 1))) {
      return index;
    }
  }
  return -1;
};
var isOfferableModelFileName = (name) => groupBoundaryAt(stripSuffix(name)) >= 0;
var foldToWords = (side) => {
  let out = "";
  let index = 0;
  while (index < side.length) {
    const character = side.charAt(index);
    if (!isSeparator(character)) {
      out += character;
      index += 1;
      continue;
    }
    let run = "";
    while (index < side.length && isSeparator(side.charAt(index))) {
      run += side.charAt(index);
      index += 1;
    }
    out += run.length > 1 && run.indexOf("+") >= 0 ? " + " : " ";
  }
  return out.trim();
};
var sentenceCase = (words) => words === "" ? words : words.charAt(0).toUpperCase() + words.slice(1);
var modelFileSearchText = (name) => stripSuffix(name).replace(SEPARATOR_RUN, " ").trim().toLowerCase();
var modelFileQueryTokens = (query) => {
  const folded = stripSuffix(query).replace(SEPARATOR_RUN, " ").trim().toLowerCase();
  return folded === "" ? [] : folded.split(" ");
};
var modelFileMatches = (name, query) => {
  const wanted = modelFileQueryTokens(query);
  if (wanted.length === 0) return true;
  const available = modelFileSearchText(name).split(" ");
  for (let i = 0; i < wanted.length; i += 1) {
    let found = false;
    for (let j = 0; j < available.length; j += 1) {
      if (available[j].indexOf(wanted[i]) === 0) {
        found = true;
        break;
      }
    }
    if (!found) return false;
  }
  return true;
};
var modelFileOptionMatchesExactly = (option, query) => {
  const folded = modelFileQueryTokens(query).join(" ");
  if (folded === "") return false;
  if (option.collided === true) {
    return stripSuffix(query).toLowerCase() === stripSuffix(option.value).toLowerCase();
  }
  return folded === modelFileSearchText(option.value) || folded === modelFileSearchText(option.label);
};
var collisionKey = (option) => {
  const label = option.label.toLowerCase();
  return "k" + label.length + ":" + label + (option.meta ?? "").toLowerCase();
};
var modelFileOptions = (names) => {
  const projected = [];
  for (let i = 0; i < names.length; i += 1) {
    const name = names[i];
    if (!isOfferableModelFileName(name)) continue;
    const base = stripSuffix(name);
    const boundary = groupBoundaryAt(base);
    projected.push({
      value: name,
      label: sentenceCase(foldToWords(base.slice(boundary + 1))),
      meta: sentenceCase(foldToWords(base.slice(0, boundary)))
    });
  }
  const seen = {};
  for (let i = 0; i < projected.length; i += 1) {
    const key = collisionKey(projected[i]);
    seen[key] = (seen[key] ?? 0) + 1;
  }
  const out = [];
  for (let i = 0; i < projected.length; i += 1) {
    const option = projected[i];
    out.push(
      seen[collisionKey(option)] > 1 ? { value: option.value, label: option.value, collided: true } : option
    );
  }
  return out;
};

// src/platform-health.ts
var PLATFORM_HEALTH_NODE_KINDS = ["customer", "twin", "device", "stream"];
var PLATFORM_HEALTH_BUCKETS = [
  "down",
  "degraded",
  "setting_up",
  "healthy",
  "disabled"
];
var PLATFORM_HEALTH_FAULT_ORIGINS = ["self", "child"];
var PLATFORM_HEALTH_METRIC_STATES = ["neutral", "degraded", "down"];
var PLATFORM_HEALTH_HISTORY_WINDOWS = ["24h", "7d"];
var HISTORY_BUCKET_VERDICTS = [
  "down",
  "degraded",
  "setting_up",
  "healthy",
  "offline"
];

// src/bi/BiHierarchyImport.ts
var BI_IMPORT_REASONS = {
  lock_contention: true,
  statement_timeout: true,
  in_progress: true,
  not_found: true,
  no_entities: true,
  other: true
};
export {
  Align,
  AppMode,
  BI_IMPORT_REASONS,
  CAMERA_LENS_FOCAL_LENGTHS,
  CAMERA_RESOLUTIONS,
  CAMERA_TYPES,
  CopilotType,
  DEFAULT_CAMERA_CONFIG,
  DEFAULT_MAP_ORIGIN,
  DataMode,
  DataScope,
  Environment,
  FLOORPLANNER_IMPORT_STATES,
  Feedback,
  FieldMode,
  FilterType,
  HISTORY_BUCKET_VERDICTS,
  IndicatorColor,
  LAUNCH_HOURS_REASONS,
  LabelMode,
  LogLevel,
  MAX_MODEL_FILE_NAME_LENGTH,
  MetricEventValueType,
  MetricValueType,
  NotificationType,
  OPENING_HOURS_CHANGED_CODE,
  OrganisationLifecycleStageValues,
  PLATFORM_HEALTH_BUCKETS,
  PLATFORM_HEALTH_FAULT_ORIGINS,
  PLATFORM_HEALTH_HISTORY_WINDOWS,
  PLATFORM_HEALTH_METRIC_STATES,
  PLATFORM_HEALTH_NODE_KINDS,
  PageMode,
  PanelAnchorPos,
  Roles,
  Section,
  ServiceType,
  TWIN_LIFECYCLE_RANK,
  TabPanel,
  Template,
  TimeUnit,
  TrackSide,
  TwinEntityType,
  TwinLifecycleStageValues,
  TwinSenseMessageDirection,
  TwinSenseMessageKind,
  TwinSenseMessageType,
  TwinSenseQosLevel,
  WEEKDAYS,
  effectiveModelFileLength,
  getUserPermissions,
  isModelReference,
  isOfferableModelFileName,
  isSelectableModelFileName,
  modelFileMatches,
  modelFileOptionMatchesExactly,
  modelFileOptions,
  modelFileQueryTokens,
  modelFileSearchText,
  modelReferenceProblem,
  normaliseAssetUid,
  resolveModelFileName
};
